import { MIGRATION_FLAG_KEY, recordKey } from './local-key-encoding.js';
const LEGACY_KEYS = {
    'skjv-studies': 'studies',
    'skjv-study-groups': 'study-groups',
    'skjv-bookmarks': 'bookmarks',
    'skjv-notes': 'notes',
    'skjv-prayer': 'prayer',
    'skjv-history': 'history',
    'skjv-memory': 'memory',
    'skjv-prefs': 'prefs',
    'skjv-chat': 'chat',
};
const PER_ITEM_NAMESPACES = ['studies', 'study-groups'];
const SPECIAL_LEGACY_KEYS = [
    { legacy: 'skjv-active-conversation', namespace: 'prefs', key: 'active-conversation' },
];
export function isMigrated() {
    if (typeof localStorage === 'undefined')
        return true;
    return localStorage.getItem(MIGRATION_FLAG_KEY) !== null;
}
/**
 * One-shot migration of pre-storage-package localStorage layout into
 * per-record envelopes under skjv-store/. Idempotent via MIGRATION_FLAG_KEY.
 * Legacy keys are NOT deleted — kept for one release as a fallback.
 */
export function migrateLegacyLocalStorage(now = () => new Date().toISOString()) {
    if (typeof localStorage === 'undefined')
        return;
    if (isMigrated())
        return;
    const ts = now();
    for (const [legacyKey, namespace] of Object.entries(LEGACY_KEYS)) {
        const raw = localStorage.getItem(legacyKey);
        if (raw === null)
            continue;
        let parsed;
        try {
            parsed = JSON.parse(raw);
        }
        catch {
            continue;
        }
        if (PER_ITEM_NAMESPACES.includes(namespace) && Array.isArray(parsed)) {
            writePerItem(namespace, parsed, ts);
        }
        else {
            writeSingleton(namespace, 'all', parsed, ts);
        }
    }
    for (const { legacy, namespace, key } of SPECIAL_LEGACY_KEYS) {
        const raw = localStorage.getItem(legacy);
        if (raw === null)
            continue;
        let parsed;
        try {
            parsed = JSON.parse(raw);
        }
        catch {
            parsed = raw;
        }
        writeSingleton(namespace, key, parsed, ts);
    }
    localStorage.setItem(MIGRATION_FLAG_KEY, ts);
}
function writePerItem(namespace, items, fallbackTs) {
    for (const item of items) {
        if (!item || typeof item !== 'object')
            continue;
        const obj = item;
        const id = typeof obj.id === 'string' ? obj.id : null;
        if (!id)
            continue;
        const updatedAt = typeof obj.updatedAt === 'string' && obj.updatedAt
            ? obj.updatedAt
            : typeof obj.lastUsedAt === 'string' && obj.lastUsedAt
                ? obj.lastUsedAt
                : fallbackTs;
        const name = typeof obj.name === 'string' ? obj.name.trim() : '';
        const envelope = {
            namespace,
            key: id,
            value: item,
            updatedAt,
            ...(name ? { displayName: name } : {}),
        };
        localStorage.setItem(recordKey(namespace, id), JSON.stringify(envelope));
    }
}
function writeSingleton(namespace, key, value, ts) {
    const envelope = {
        namespace,
        key,
        value,
        updatedAt: ts,
    };
    localStorage.setItem(recordKey(namespace, key), JSON.stringify(envelope));
}
//# sourceMappingURL=local-migration.js.map